const TextInput = ({ title, value, onChange, placeholder, variant = "vertical",gap = "gap-2" }) => {
  return (
    <div className={variant === "vertical" ? "flex flex-col" : `flex flex-row items-center justify-center ${gap}`}>
      <label className="text-xs text-gray-600 mb-1 block">{title}</label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={variant === "vertical" ? "w-full border border-gray-300 rounded px-2 py-1 text-xs" : "w-full border border-gray-300 rounded px-2 py-1 text-xs"}
        placeholder={placeholder}
      />
    </div>
  )
}

export default TextInput;